/* DYLUMA: deterministic scroll state. No scroll interception, timers or render loop at rest. */
(() => {
  'use strict';
  const clamp = v => Math.max(0, Math.min(1, v));
  const ramp = (p,a,b) => {const t=clamp((p-a)/(b-a));return t*t*(3-2*t);};
  const windowed = (p,a,b,c,d) => ramp(p,a,b)*(1-ramp(p,c,d));
  function legacyState(p,mobile,width,height=width) {
    const exit = 1-ramp(p,4.8,5.25);
    const m2=ramp(p,2.85,3.2),m3=ramp(p,3.9,4.25);
    const presence=ramp(p,.22,.82);
    const move=ramp(p,.8,1.25),center=ramp(p,4.8,5.15);
    return {
      symbol:1-ramp(p,.08,.55),symbolScale:1-.65*ramp(p,0,.65),
      bottle:presence*(1-ramp(p,5.3,5.65)),
      x:mobile?0:width*.21*move*(1-center),y:mobile?-height*.09*(1-ramp(p,1.6,2.05)):0,
      scale:.88+.12*presence+(mobile?.65:.9)*ramp(p,5,5.6),rotation:-4*move*(1-center),
      intro:windowed(p,.95,1.2,1.65,1.95),textY:15*(1-ramp(p,.95,1.2)),
      m1:ramp(p,1.8,2.1)*(1-m2)*exit,m2:m2*(1-m3)*exit,m3:m3*exit,
      word1:windowed(p,2.08,2.25,2.65,2.84),word2:windowed(p,3.16,3.32,3.72,3.9),word3:windowed(p,4.22,4.38,4.73,4.93),
      formula:ramp(p,5.22,5.86),formulaScale:1.09-.09*ramp(p,5.3,6.5),formulaTitle:ramp(p,5.92,6.22),
      cue:windowed(p,.55,.85,1.5,1.8),header:windowed(p,1.05,1.25,1.7,1.9)+ramp(p,6.4,6.6)
    };
  }
  const RESULT_START=4.95,RESULT_LENGTH=3.4,TOTAL=13.6;
  function approvedState(p,mobile,width,height=width) {
    const q=clamp((p-RESULT_START)/RESULT_LENGTH);
    const legacy=p<=RESULT_START?p:p>=RESULT_START+RESULT_LENGTH?p-RESULT_LENGTH:RESULT_START;
    const s=legacyState(legacy,mobile,width,height);
    // Hero-only offsets return exactly to zero before NUTRE.
    const breathe=windowed(p,.98,1.25,1.65,1.95);
    s.x+=1.5*breathe;s.y-=3*breathe;s.scale+=.006*breathe;s.rotation+=.3*breathe;
    s.m1+=.12*windowed(p,1,1.4,1.75,2.08);s.heroDrift=4*breathe;
    const inResult=p>RESULT_START;
    const leave=ramp(legacy,5.22,5.86);
    s.result=inResult?ramp(q,.08,.18)*(1-leave):0;
    s.resultCopy=inResult?windowed(q,.76,.80,.88,.96)*(1-leave):0;
    s.resultMask=inResult?ramp(q,.53,.78):0;
    s.resultZoom=1+.1*ramp(q,.88,1)+.6*ramp(legacy,5.02,5.86);
    s.resultLight=1+.35*ramp(legacy,5.02,5.86);
    s.drop=0;s.dropX=0;s.dropY=0;s.dropScale=1;s.cap=0;s.capFrame=0;
    if(inResult&&p<RESULT_START+RESULT_LENGTH){
      const travel=ramp(q,.18,.30),back=ramp(q,.88,1),mix=travel*(1-back);
      const targetScale=mobile?.34:.3;
      const bottleHeight=mobile?height*.61:Math.min(height*.75,800);
      const half=bottleHeight*targetScale*.5;
      const targetRotation=170,angle=targetRotation*Math.PI/180;
      const womanX=width*(mobile?.5:.63);
      const centerX=womanX-Math.sin(angle)*half;
      const centerY=height*.25;
      s.x=s.x*(1-mix)+(centerX-width*.5)*mix;
      s.y=s.y*(1-mix)+(centerY-height*(mobile?.54:.5))*mix;
      s.scale=s.scale*(1-mix)+targetScale*mix;
      s.rotation=s.rotation*(1-mix)+targetRotation*mix;
      s.m3*=1-ramp(q,.02,.18);s.word3=0;s.header=0;
      s.cap=windowed(q,.30,.315,.91,.93);
      s.capFrame=3*ramp(q,.315,.40)*(1-ramp(q,.88,.91));
      const fall=ramp(q,.43,.50);
      const nozzleY=centerY-Math.cos(angle)*half;
      s.drop=windowed(q,.40,.43,.50,.53);
      s.dropX=womanX;s.dropY=nozzleY+(height*.416-nozzleY)*fall;
      s.dropScale=(.25+.75*ramp(q,.40,.43))*(1-.7*ramp(q,.50,.53));
    }
    if(p>=RESULT_START+RESULT_LENGTH&&legacy<5.25)s.m3=0;
    s.legacy=legacy;s.resultProgress=q;
    return s;
  }
  function state(p,mobile,width,height=width) {
    // Extra Formula time starts after the entire approved Result and macro.
    const original=p<=9.65?p:p<13.25?9.65:p-3.6;
    const s=approvedState(original,mobile,width,height);
    // V8.2: continuous motion only inside the approved three-word chapter.
    const journey=ramp(p,1.95,4.95),envelope=windowed(p,1.95,2.2,4.7,4.95);
    s.x+=width*(mobile?.022:.048)*Math.sin(journey*Math.PI*2)*envelope;
    s.y+=height*(mobile?.012:.055)*(1-2*journey)*envelope;
    s.scale+=.055*Math.sin(journey*Math.PI)*envelope;
    s.rotation+=(mobile?.8:2.1)*Math.sin(journey*Math.PI*2)*envelope;
    s.chapterDepth=envelope*(journey-.5);
    s.formulaOne=windowed(p,9.3,9.6,10,10.25);
    s.formulaTwo=windowed(p,10.4,10.65,11.05,11.3);
    s.formulaThree=windowed(p,11.45,11.75,12.2,12.45);
    s.formulaClose=windowed(p,12.6,12.85,13.5,13.6);
    const camera=ramp(p,9.65,12.2),settle=ramp(p,12.2,13.6);
    s.formulaScale+=.07*camera-.025*settle;
    s.formulaX=width*.006*camera*(1-.4*settle);
    s.formulaY=-height*.008*camera*(1-.5*settle);
    s.formulaLight=1+.02*camera-.01*settle;
    s.formulaVeil=ramp(p,13.3,13.6);
    return s;
  }
  // Export the pure evaluator for local verification; no store data is exposed.
  window.DylumaDirector = {state};
  let teardown;
  const initialize = () => {
    if(teardown) teardown();
    const story=document.querySelector('[data-dc-story]');if(!story)return;
    document.documentElement.classList.add('dc-has-story');
    const stage=story.querySelector('.dc-stage');
    const media=window.matchMedia('(prefers-reduced-motion: reduce)');
    const root=document.documentElement,header=document.querySelector('.d-header');
    const controller=new AbortController(),options={signal:controller.signal};
    let frame=0,active=false,override=null;
    const preference=()=>{if(override!==null)return override;try{return sessionStorage.getItem('dyluma-static')==='1';}catch{return false;}};
    const buttons=document.querySelectorAll('[data-dc-motion]');
    const setMode = () => {
      active=!media.matches&&!preference()&&!navigator.connection?.saveData;
      root.classList.toggle('dc-active',active);
      buttons.forEach(b=>{b.textContent=active?'Riduci movimento':'Attiva movimento';b.setAttribute('aria-pressed',String(!active));b.hidden=media.matches;});
      if(!active){header?.style.removeProperty('--dc-header');header?.style.removeProperty('--dc-header-y');header?.classList.remove('dc-on-ivory','is-reachable');}
      if(!active){story.querySelectorAll('[data-result-static-src]').forEach(img=>{img.src=img.dataset.resultStaticSrc;});story.querySelectorAll('[data-result-static-srcset]').forEach(el=>{el.srcset=el.dataset.resultStaticSrcset;});}
      const staticFormula=story.querySelector('[data-formula-static]');
      if(staticFormula){staticFormula.inert=active;staticFormula.setAttribute('aria-hidden',String(active));}
      story.querySelectorAll('[data-formula-moment]').forEach(el=>{el.inert=true;el.setAttribute('aria-hidden','true');});
      schedule();
    };
    const loadResult = progress => {
      if(progress<3.9)return;
      const mobile=window.innerWidth<=760;
      story.querySelectorAll('[data-result-src]').forEach(img=>{const src=mobile?img.dataset.resultMobile:img.dataset.resultSrc;if(img.getAttribute('src')!==src)img.src=src;});
      story.querySelectorAll('[data-cap-src]').forEach(img=>{if(!img.getAttribute('href'))img.setAttribute('href',img.dataset.capSrc);});
    };
    const paintResult = s => {
      const t=s.resultMask;
      let mask='linear-gradient(transparent,transparent)';
      if(t>=.999)mask='linear-gradient(#000,#000)';
      else if(t>0){const a=2+150*t,b=2+190*t;mask=`radial-gradient(ellipse ${a}% ${b}% at 49% 20%,#000 0%,#000 42%,transparent 61%),radial-gradient(ellipse ${a*.75}% ${b*.8}% at 40% 27%,#000 0%,#000 38%,transparent 65%),radial-gradient(ellipse ${a*.65}% ${b*.95}% at 60% 23%,#000 0%,#000 36%,transparent 64%)`;}
      const capReady=story.querySelector('[data-cap-src]')?.getAttribute('href');
      const vars={result:s.result,'result-copy':s.resultCopy,'result-mask':mask,'result-zoom':s.resultZoom,'result-light':s.resultLight,'hero-drift':s.heroDrift+'px',drop:s.drop,'drop-x':s.dropX+'px','drop-y':s.dropY+'px','drop-scale':s.dropScale,cap:capReady?s.cap:0,'cap-cut':capReady&&s.cap>.99?'13.55%':'0%'};
      // Decorative Result text uses the existing local progress; no scene timing changes.
      const q=s.resultProgress;
      const spans=[[.15,.18,.42,.45],[.45,.475,.675,.70],[.70,.725,.925,.95]];
      spans.forEach((range,i)=>{
        const n=i+1,depth=ramp(q,range[0],range[3]);
        vars['micro-'+n]=windowed(q,...range);
        vars['micro-scale-'+n]=.8+.2*ramp(q,range[0],range[1])+.14*ramp(q,range[2],range[3]);
        vars['micro-y-'+n]=(10-13*depth)+'px';
        vars['micro-blur-'+n]=(.65*(1-ramp(q,range[0],range[1])))+'px';
      });
      const lo=Math.floor(s.capFrame),f=s.capFrame-lo;
      for(let i=0;i<4;i++)vars['cap-'+i]=i===lo?1-f:i===lo+1?f:0;
      Object.entries(vars).forEach(([key,value])=>stage.style.setProperty('--dc-'+key,value));
    };
    const loadMedia = progress => {
      const mobile=window.innerWidth<=760;
      story.querySelectorAll('[data-dc-media]').forEach(img=>{
        if(img.classList.contains('dc-formula')&&progress<4.2)return;
        const src=mobile?img.dataset.mobile:img.dataset.src;
        if(img.getAttribute('src')!==src)img.src=src;
      });
    };
    const update = () => {
      frame=0;if(!active||document.hidden)return;
      const rect=story.getBoundingClientRect(),height=stage.clientHeight||window.innerHeight;
      const progress=clamp(-rect.top/Math.max(1,story.offsetHeight-height))*TOTAL;
      const s=state(progress,window.innerWidth<=760,stage.clientWidth||window.innerWidth,height);
      if(window.innerWidth<=760){
        const dpr=window.devicePixelRatio||1,align=v=>Math.round(v*dpr)/dpr;
        const markWidth=align(Math.max(60,Math.min(65,window.innerWidth*.158)));
        stage.style.setProperty('--dc-mark-width',markWidth+'px');
        stage.style.setProperty('--dc-mark-left',align((stage.clientWidth-markWidth)/2)+'px');
        stage.style.setProperty('--dc-mark-top',align((height-markWidth*385/280)/2)+'px');
        stage.style.setProperty('--dc-mark-transform',s.symbolScale===1?'none':`scale(${s.symbolScale})`);
      }
      const vars={symbol:s.symbol,'symbol-scale':s.symbolScale,bottle:s.bottle,x:s.x+'px',y:s.y+'px',scale:s.scale,rotation:s.rotation+'deg',intro:s.intro,'text-y':s.textY+'px',m1:s.m1,m2:s.m2,m3:s.m3,word1:s.word1,word2:s.word2,word3:s.word3,formula:s.formula,'formula-scale':s.formulaScale,'formula-title':s.formulaTitle,cue:s.cue};
      Object.entries(vars).forEach(([key,value])=>stage.style.setProperty('--dc-'+key,value));
      stage.style.setProperty('--dc-chapter-depth',s.chapterDepth);
      if(progress>.8)loadMedia(s.legacy);
      loadResult(progress);
      paintResult(s);
      const formulaVars={'formula-one':s.formulaOne,'formula-two':s.formulaTwo,'formula-three':s.formulaThree,'formula-close':s.formulaClose,'formula-x':s.formulaX+'px','formula-y':s.formulaY+'px','formula-light':s.formulaLight,'formula-veil':s.formulaVeil};
      Object.entries(formulaVars).forEach(([key,value])=>stage.style.setProperty('--dc-'+key,value));
      story.querySelectorAll('[data-formula-moment]').forEach(el=>{const visible=s[el.dataset.formulaMoment]>.5;el.inert=!visible;el.setAttribute('aria-hidden',String(!visible));});
      if(header){const after=rect.bottom<=height;const show=after?1:s.header;header.style.setProperty('--dc-header',show);header.style.setProperty('--dc-header-y',show>.01?'0px':'-100%');header.classList.toggle('is-reachable',show>.5);const navyAtHeader=Array.from(document.querySelectorAll('[data-dc-header-tone="navy"]')).some(el=>{const box=el.getBoundingClientRect();return box.top<=40&&box.bottom>40;});header.classList.toggle('dc-on-ivory',s.legacy>5.7&&!navyAtHeader);}
    };
    function schedule(){if(!frame)frame=requestAnimationFrame(update);}
    window.addEventListener('scroll',schedule,{...options,passive:true});
    window.addEventListener('resize',schedule,options);
    window.visualViewport?.addEventListener('resize',schedule,options);
    document.addEventListener('shopify:block:select',event=>{if(active&&event.target.closest('.df-ingredients')){const target=window.scrollY+story.getBoundingClientRect().top+(story.offsetHeight-stage.clientHeight)*13/TOTAL;window.scrollTo({top:target,behavior:'instant'});schedule();}},options);
    window.addEventListener('pageshow',schedule,options);
    document.addEventListener('visibilitychange',schedule,options);
    media.addEventListener('change',setMode,options);
    buttons.forEach(button=>button.addEventListener('click',()=>{
      const wasActive=active;override=wasActive;
      try{sessionStorage.setItem('dyluma-static',wasActive?'1':'0');}catch{}
      setMode();if(!wasActive)story.scrollIntoView({behavior:'instant'});
    },options));
    story.querySelector('.dc-scroll-cue')?.addEventListener('click',event=>{
      if(active){event.preventDefault();const target=window.scrollY+story.getBoundingClientRect().top+(story.offsetHeight-stage.clientHeight)*2.1/TOTAL;window.scrollTo({top:target,behavior:'smooth'});}
    },options);
    document.querySelectorAll('a[href$="#prodotto"]').forEach(link=>link.addEventListener('click',event=>{
      const target=document.getElementById('prodotto');if(!target||target.closest('[hidden]'))return;
      event.preventDefault();target.scrollIntoView({behavior:'instant'});target.tabIndex=-1;target.focus({preventScroll:true});history.replaceState(null,'','#prodotto');schedule();
    },options));
    setMode();
    // Reconcile restored/deep-linked page positions after sticky geometry is applied.
    if(location.hash==='#prodotto')requestAnimationFrame(()=>document.getElementById('prodotto')?.scrollIntoView({behavior:'instant'}));
    teardown=()=>{controller.abort();if(frame)cancelAnimationFrame(frame);root.classList.remove('dc-active','dc-has-story');};
  };
  window.DylumaDirector.refresh=initialize;
  initialize();
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('shopify:section:unload',()=>{if(!document.querySelector('[data-dc-story]')&&teardown)teardown();});
})();
